var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.145 23H9C8.20435 23 7.44129 22.6839 6.87868 22.1213C6.31607 21.5587 6 20.7956 6 20V9C6 8.20435 6.31607 7.44129 6.87868 6.87868C7.44129 6.31607 8.20435 6 9 6H20C20.7956 6 21.5587 6.31607 22.1213 6.87868C22.6839 7.44129 23 8.20435 23 9V11.036",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.229 24C20.6135 24 21.9669 23.5895 23.118 22.8203C24.2691 22.0511 25.1663 20.9579 25.6962 19.6788C26.226 18.3997 26.3646 16.9922 26.0945 15.6344C25.8244 14.2765 25.1577 13.0292 24.1788 12.0503C23.1998 11.0713 21.9525 10.4046 20.5946 10.1345C19.2368 9.86441 17.8293 10.003 16.5502 10.5328C15.2711 11.0627 14.1779 11.9599 13.4087 13.111C12.6395 14.2622 12.229 15.6155 12.229 17C12.229 18.8565 12.9665 20.637 14.2793 21.9497C15.592 23.2625 17.3725 24 19.229 24Z",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.229 18.913C22.7874 19.5703 22.1876 20.1059 21.4848 20.4706C20.7819 20.8353 19.9986 21.0173 19.207 21C18.4161 21.0044 17.6369 20.8091 16.9415 20.4322C16.2461 20.0553 15.6571 19.5091 15.229 18.844M15.729 15.921C15.7399 15.6664 15.8513 15.4265 16.0387 15.2539C16.2262 15.0813 16.4744 14.99 16.729 15C16.9836 14.99 17.2318 15.0813 17.4193 15.2539C17.6067 15.4265 17.7181 15.6664 17.729 15.921M20.729 15.921C20.7399 15.6664 20.8513 15.4265 21.0387 15.2539C21.2262 15.0813 21.4744 14.99 21.729 15C21.9836 14.99 22.2318 15.0813 22.4193 15.2539C22.6067 15.4265 22.7181 15.6664 22.729 15.921",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.229 10H19.229",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.229 14H12.229",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.229 18H12.229",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsFeedback);
export default __webpack_public_path__ + "static/media/settings-feedback.57436d6725c5cae811caaff8b1af271f.svg";
export { ForwardRef as ReactComponent };